var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "button",
        {
          staticClass: "btn-outline button-secondary",
          staticStyle: { "font-weight": "bold" },
          on: {
            click: function ($event) {
              return _vm.openModal()
            },
          },
        },
        [
          _c("i", { staticClass: "fa-classic fa-arrow-up-from-line" }),
          _vm._v("Bulk Import"),
        ]
      ),
      _vm._v(" "),
      _vm.isAlertOpen
        ? _c("alert-modal", [
            _c("span", [
              _c("i", { staticClass: "fa-solid fa-circle-check" }),
              _vm._v(
                "Bulk allocation complete: " +
                  _vm._s(_vm.countCreated) +
                  " new, " +
                  _vm._s(_vm.countExisting) +
                  " existing"
              ),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.isModalOpen
        ? _c("div", { staticClass: "modal-container" }, [
            _c("div", { staticClass: "modal-content" }, [
              _c("h1", [
                _vm._v("Bulk VIBAN Allocation"),
                _c("i", {
                  staticClass: "fa-regular fa-xmark",
                  on: {
                    click: function ($event) {
                      return _vm.closeModal()
                    },
                  },
                }),
              ]),
              _vm._v(" "),
              _c(
                "span",
                { staticStyle: { "font-weight": "normal", color: "#717182" } },
                [
                  _vm._v(
                    "Upload a CSV file with client numbers to allocate VIBANs in bulk."
                  ),
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "information-container" }, [
                _c("i", { staticClass: "fa-regular fa-file-lines" }),
                _vm._v(" "),
                _vm._m(0),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "download-btn btn btn-outline",
                    on: { click: _vm.exportCSVTemplate },
                  },
                  [
                    _c("i", {
                      staticClass: "fa-regular fa-arrow-down-to-bracket",
                    }),
                    _vm._v("Download Template"),
                  ]
                ),
              ]),
              _vm._v(" "),
              _vm.clients.length == 0
                ? _c(
                    "div",
                    {
                      staticClass: "drop-zone",
                      class: { hover: _vm.isDragOver },
                      on: {
                        dragover: function ($event) {
                          $event.preventDefault()
                        },
                        dragenter: function ($event) {
                          $event.preventDefault()
                          _vm.isDragOver = true
                        },
                        dragleave: function ($event) {
                          $event.preventDefault()
                          _vm.isDragOver = false
                        },
                        drop: function ($event) {
                          $event.preventDefault()
                          return _vm.onDrop.apply(null, arguments)
                        },
                      },
                    },
                    [
                      _c("i", {
                        staticClass: "fa-regular fa-arrow-up-from-bracket",
                      }),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(
                          "Drag and drop your CSV file here, or click to browse"
                        ),
                      ]),
                      _vm._v(" "),
                      _c("span", [_vm._v("CSV file with clientNumber column")]),
                      _vm._v(" "),
                      _c("div", [
                        _c(
                          "button",
                          {
                            staticClass: "btn-outline btn-dark",
                            attrs: { type: "file" },
                            on: { click: _vm.importCSVFile },
                          },
                          [
                            _c("i", {
                              staticClass:
                                "fa-regular fa-arrow-up-from-bracket",
                            }),
                            _vm._v(" Select CSV file"),
                          ]
                        ),
                      ]),
                    ]
                  )
                : _c("div", [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          display: "flex",
                          "justify-content": "space-between",
                          "align-items": "center",
                          "font-size": "1.25rem",
                          "font-weight": "bold",
                          color: "black",
                        },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            "Preview (" +
                              _vm._s(_vm.clients.length) +
                              " allocations)"
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticStyle: { display: "flex", gap: "1rem" } },
                          [
                            _c(
                              "span",
                              {
                                class: {
                                  "btn-outline button-primary":
                                    _vm.clients.filter(function (item) {
                                      return item.status == 0
                                    }).length > 0,
                                  "btn-outline-light btn":
                                    _vm.clients.filter(function (item) {
                                      return item.status == 0
                                    }).length == 0,
                                },
                                style: {
                                  cursor: "default",
                                  "pointer-events": "none",
                                  "background-color":
                                    _vm.clients.filter(function (item) {
                                      return item.status == 0
                                    }).length > 0
                                      ? "#f0fdf4"
                                      : "white",
                                  color:
                                    _vm.clients.filter(function (item) {
                                      return item.status == 0
                                    }).length > 0
                                      ? "#008236"
                                      : "",
                                },
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.clients.filter(function (item) {
                                      return item.status == 0
                                    }).length
                                  ) + " valid"
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass: "btn-outline-light btn",
                                on: {
                                  click: function ($event) {
                                    _vm.clients = []
                                  },
                                },
                              },
                              [
                                _c("i", { staticClass: "fa-regular fa-xmark" }),
                                _vm._v(" Clear"),
                              ]
                            ),
                          ]
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "tables" }, [
                      _vm._m(1),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "tbody" },
                        _vm._l(_vm.clients, function (item, index) {
                          return _c("div", { key: index, staticClass: "tr" }, [
                            _c("td", [_vm._v(_vm._s(index + 1))]),
                            _vm._v(" "),
                            _c("td", [
                              item.status == 0
                                ? _c("i", {
                                    staticClass: "fa-regular fa-circle-check",
                                    staticStyle: { color: "#00a63e" },
                                  })
                                : _c("i", {
                                    staticClass: "fa-regular fa-circle-xmark",
                                    staticStyle: { color: "#155dfc" },
                                  }),
                            ]),
                            _vm._v(" "),
                            _c(
                              "td",
                              {
                                staticStyle: {
                                  color: "black",
                                  "font-weight": "bold",
                                },
                              },
                              [_vm._v(_vm._s(item.clientNumber))]
                            ),
                            _vm._v(" "),
                            item.status == 0
                              ? _c(
                                  "td",
                                  { staticStyle: { color: "#00a63e" } },
                                  [_vm._v("Will allocate new VIBAN")]
                                )
                              : _c(
                                  "td",
                                  { staticStyle: { color: "#155dfc" } },
                                  [
                                    _vm._v(
                                      "Already allocated: " + _vm._s(item.VIBAN)
                                    ),
                                  ]
                                ),
                          ])
                        }),
                        0
                      ),
                    ]),
                    _vm._v(" "),
                    _vm.clients.some(function (item) {
                      return item.status == 1
                    })
                      ? _c("div", { staticClass: "information-container" }, [
                          _c("i", {
                            staticClass: "fa-regular fa-circle-exclamation",
                          }),
                          _vm._v(" "),
                          _c("div", [
                            _c("span", [
                              _vm._v("Existing Allocations Detected:"),
                            ]),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.clients.filter(function (item) {
                                    return item.status == 1
                                  }).length
                                ) +
                                  " client(s) already have VIBANs allocated. These will be returned without allocating new VIBANs."
                              ),
                            ]),
                          ]),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("hr"),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticStyle: {
                          display: "flex",
                          "justify-content": "space-between",
                          "align-items": "center",
                        },
                      },
                      [
                        _c(
                          "button",
                          {
                            staticClass: "btn-outline-light btn",
                            on: { click: _vm.closeModal },
                          },
                          [_vm._v("Cancel")]
                        ),
                        _vm._v(" "),
                        _vm.clients.filter(function (item) {
                          return item.status == 0
                        }).length > 0
                          ? _c(
                              "button",
                              {
                                staticClass: "btn-outline btn-dark",
                                on: { click: _vm.allocate },
                              },
                              [
                                _vm._v(
                                  "Process " +
                                    _vm._s(
                                      _vm.clients.filter(function (item) {
                                        return item.status == 0
                                      }).length
                                    ) +
                                    " Allocations"
                                ),
                              ]
                            )
                          : _vm._e(),
                      ]
                    ),
                  ]),
            ]),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("span", [_vm._v("CSV Template")]),
      _vm._v(" "),
      _c("span", [_vm._v("Download template with sample client numbers")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "thead" }, [
      _c("th", [_vm._v("#")]),
      _vm._v(" "),
      _c("th", [_vm._v("Status")]),
      _vm._v(" "),
      _c("th", [_vm._v("Client Number")]),
      _vm._v(" "),
      _c("th", [_vm._v("Result")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }